export const storesTableWidths = {
  id: 120,
  stores: 200,
  email: 200,
  ratings: 180,
  products: 135,
  visitors: 110,
  sold: 120,
  revenue: 120,
  country:312,
  status:311
}